<template>
    <div class="news-list-item tapable_el" tapmode @click.stop="openContent()">
        <div class="news-list-item-title  text-overflow"    v-html="data.title"> </div>

        <div class="news-list-item-bigimg" >
            <div class="news-list-item-palyicon">
                <img src="../assets/icons_play.svg">
            </div>
            <img v-if="data.thumb" @error="setdefaultImg($event)" v-lazy="data.thumb[0]+'?x-oss-process=image/resize,m_lfit,h_240,w_700'" class="news-list-item-bigimg-img">
        </div>
        <div class="news-list-item-date"  >

            <span  v-if="data.author">{{data.author}}</span>
            <span>{{data.format_time}}</span>
            <span v-if="data.pv_num">
            <svg  viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="7456" width="200" height="200"><path d="M999.722667 449.024C886.912 324.864 699.733333 193.621333 512 196.266667 324.266667 193.578667 137.088 324.906667 24.234667 449.024a94.336 94.336 0 0 0 0 125.781333C135.722667 697.642667 320.298667 827.733333 505.130667 827.733333h13.141333c185.472 0 369.962667-130.090667 481.578667-252.970666a94.293333 94.293333 0 0 0-0.128-125.738667zM315.733333 512a196.266667 196.266667 0 1 1 196.266667 196.266667A196.266667 196.266667 0 0 1 315.733333 512z" p-id="7457" fill="#9c9c9c"></path><path d="M512 512m-85.333333 0a85.333333 85.333333 0 1 0 170.666666 0 85.333333 85.333333 0 1 0-170.666666 0Z" p-id="7458" fill="#9c9c9c"></path></svg>
            <i>{{data.pv_num>10000?(data.pv_num/10000).toFixed(1)+'万':data.pv_num}}</i>
        </span>
            <span v-if="data.comment_num">
            <svg  class="news-list-replay-icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="5792" width="200" height="200"><path d="M144.5 123.7H881c44 0 79.6 35.6 79.6 79.6v537.4c0 44-35.6 79.6-79.6 79.6H662.7c-13.2 0-26 4.3-36.4 12.4l-73.8 56.7c-22.9 17.6-55.2 16.3-76.5-3.1l-55.5-50.4c-11-10-25.3-15.5-40.2-15.5H144.5c-44 0-79.6-35.6-79.6-79.6V203.3c-0.1-43.9 35.6-79.6 79.6-79.6z m109.4 398.1c38.5 0 69.7-31.2 69.7-69.7s-31.2-69.7-69.7-69.7-69.7 31.2-69.7 69.7 31.3 69.7 69.7 69.7z m258.8 0c38.5 0 69.7-31.2 69.7-69.7s-31.2-69.7-69.7-69.7-69.7 31.3-69.7 69.8 31.2 69.6 69.7 69.6z m258.8 0c38.5 0 69.7-31.2 69.7-69.7s-31.2-69.7-69.7-69.7-69.7 31.2-69.7 69.7 31.2 69.7 69.7 69.7z" p-id="5793" fill="#9c9c9c"></path></svg>
            <i>{{data.comment_num}}</i>
        </span>


        </div>
    </div>
</template>

<script>
    import utils from "../utils";

    export default {
        name: "newsVideoItem",
        props: {
            data: Object,
            is_spec: Boolean,
            nav_url: String,
            title: String,
        },
        methods: {
            setdefaultImg(event) {
                var el = event.currentTarget;
                el.style.opacity = 0
            },
            openContent() {
                if (this.data.art_link) {
                    utils.openPage(this.data,this)
                } else {
                    this.$router.push({name: "NewsContent", params: {id: this.data.art_id}})
                }

            }
        },
    }
</script>

<style scoped>

</style>
